import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { getAnalyticsConsent } from "@/lib/analytics"

/** Fire PostHog pageview on SPA route changes — only when consent granted. */
export function RoutePageview() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    if (getAnalyticsConsent() !== "accepted") return
    if (typeof window.posthog?.capture === "function") {
      window.posthog.capture("$pageview", { $current_url: window.location.href })
    }
  }, [pathname, search])

  return null
}
